module.exports = __webpack_public_path__ + "static/media/blue-add.c634e71e.svg";